import { Button, Modal, TextField } from "@material-ui/core";
import React, { useState } from "react";
import SaveIcon from "@material-ui/icons/Save";
import { useMutation, useQueryClient } from "react-query";
import { addBrand } from "../../services/brand.service";
import { ReactComponent as LoadingIcon } from "../../assets/svgs/loading-icon.svg";
import { toast } from "react-toastify";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";

interface Props {
  open: boolean;
  handleClose: () => void;
}

const AddBrandModal: React.FC<Props> = ({ open, handleClose }) => {
  const [errTarget, setErrTarget] = useState("");
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [taxNo, setTaxNo] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");

  const queryClient = useQueryClient();
  const { isLoading, mutate } = useMutation(addBrand, {
    onSuccess: () => {
      queryClient.invalidateQueries("brands");
      setName("");
      setDescription("");
      setTaxNo("");
      setPhoneNumber("");
      setErrTarget("");
      handleClose();
    },
    onError: (err: any) => {
      const field = err.response.data.errorField;
      let message = "";
      if (field === "taxNo_unique") {
        message = "Tax No. has already been used !";
        setErrTarget("taxNo");
      } else if (field === "name_unique") {
        message = "Brand Name has already been used !";
        setErrTarget("name");
      }
      toast.error(`${message ? message : "Technical Fault, contact Admin !"}`, {
        autoClose: 2200,
      });
    },
  });

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    mutate({ name, description, taxNo, phoneNumber });
  };

  return (
    <div>
      <Modal
        onClose={handleClose}
        open={open}
        className="flex justify-center items-center"
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <form
            onSubmit={handleSubmit}
            style={{ width: "520px" }}
            className="bg-white rounded-md flex flex-col w-full focus:outline-none"
          >
            <div className="flex-1 bg-white w-full rounded-t-md p-5">
              <p className="text-blue-500 font-medium text-2xl">
                Add new Brand
              </p>
              <div className="pt-5 w-full space-y-5">
                <TextField
                  id="name"
                  label="Brand Name"
                  variant="outlined"
                  className="w-full"
                  autoFocus
                  required
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  error={errTarget === "name"}
                  inputProps={{ maxLength: 191 }}
                />
                <TextField
                  id="tax"
                  label="Tax No."
                  type="number"
                  variant="outlined"
                  className="w-full"
                  required
                  value={taxNo}
                  onChange={(e) => setTaxNo(e.target.value)}
                  error={errTarget === "taxNo"}
                  inputProps={{ maxLength: 30 }}
                />
                <TextField
                  id="phone"
                  label="Call Center Number"
                  type="number"
                  variant="outlined"
                  className="w-full"
                  required
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  inputProps={{ maxLength: 15 }}
                />
                <TextField
                  className="w-full"
                  id="description"
                  label="Description"
                  multiline
                  rows={3}
                  variant="outlined"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  inputProps={{ maxLength: 500 }}
                />
              </div>
            </div>
            <div className="h-16 w-full bg-gray-100 rounded-b-md flex justify-end space-x-4 items-center px-5">
              <Button
                onClick={handleClose}
                color="primary"
                variant="contained"
                className="focus:outline-none"
              >
                Cancel
              </Button>
              <Button
                disabled={isLoading}
                type="submit"
                variant="contained"
                color="primary"
                className="focus:outline-none"
                startIcon={<SaveIcon />}
              >
                {isLoading ? (
                  <LoadingIcon className="text-blue-600 animate-spin h-5 w-5" />
                ) : (
                  "Save"
                )}
              </Button>
            </div>
          </form>
        </Fade>
      </Modal>
    </div>
  );
};

export default AddBrandModal;
